export default __webpack_public_path__ + "ae39f743fdcf8f64531ec2e8cdccb2d5.ttf";